import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '@/store/apiSlice';
import modalReducer from '@/store/modalSlice';
import cacheReducer from '@/store/cacheSlice.ts';
import uiReducer from '@/store/uiSlice';
import installReducer from '@/store/installSlice';
import { metricsListener } from '@/store/metricsMiddleware';

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        modal: modalReducer,
        cache: cacheReducer,
        ui: uiReducer,
        install: installReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware).prepend(metricsListener.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
